export const CHART_BAR_DECIMALS = 1

export const CHART_BAR_UNIT_FREQUENCY = '#'
export const CHART_BAR_DECIMALS_FREQUENCY = 2

export const MIN_WIDTH = 860
